import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';

// Components
import InputField from '../../../../../atoms/InputField/InputField';

function Accounting({ formik, productType }) {
  const { t } = useTranslation();

  const getInput = useCallback((name, type, icon, max) => (
    <div className="m-b-15">
      <InputField
        type={type || 'text'}
        id={`${productType}_logistic_${name}`}
        name={name}
        value={formik.values[name]}
        label={t(`product.logistic.form.${name}`)}
        formik={{
          handleChange: formik.handleChange,
          handleBlur: formik.handleBlur,
          setFieldValue: formik.setFieldValue,
        }}
        error={formik.errors?.[name] && formik.touched?.[name] ? formik.errors[name] : null}
        isRequired
        full
        icon={icon}
        maxNumberValue={max}
        step={0.10}
      />
    </div>
  ), [formik]);

  return (
    <div>
      <h3 className="fs-20 m-b-25">
        {t('product.logistic.sub.seasonPrices')}
        <span className="m-l-5">*</span>
      </h3>

      <div className="d-flex f-wrap">
        <div className="m-r-20">
          {getInput('lowSeasonPrice', 'number', <span className="fs-18">€</span>)}
        </div>
        <div className="m-r-20">
          {getInput('mediumSeasonPrice', 'number', <span className="fs-18">€</span>)}
        </div>
        <div className="m-r-20">
          {getInput('highSeasonPrice', 'number', <span className="fs-18">€</span>)}
        </div>
      </div>

      <span className="d-block fs-14 c-neutral-03 m-t-10">
        {`* ${t('product.logistic.taxIncluded')}`}
      </span>

      <hr className="m-t-30 m-b-40" />

      <h3 className="fs-20 m-b-25">{t('product.logistic.sub.accounting')}</h3>

      <div className="d-flex f-wrap">
        <div className="m-r-20 flex-auto input_max">
          {getInput('accountingCode')}
        </div>
        <div>
          {getInput('taxRate', 'number', null, 99)}
        </div>
      </div>
    </div>
  );
}

Accounting.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      accountingCode: PropTypes.string,
    }),
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    errors: PropTypes.shape({}),
    touched: PropTypes.shape({}),
  }).isRequired,
  productType: PropTypes.string.isRequired,
};

export default Accounting;
